if (!customElements.get('sangdouleur-cart-drawer-discount')) {
  customElements.define(
    'sangdouleur-cart-drawer-discount',
    class SangdouleurCartDrawerDiscount extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.message = this.querySelector('.sangdouleur-cart-drawer__discount-message');

        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);

        this.form?.addEventListener('submit', this.onSubmit);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const removeButton = event.target.closest('[data-discount-remove]');
        if (!removeButton) return;

        event.preventDefault();
        this.applyDiscount('');
      }

      onSubmit(event) {
        event.preventDefault();

        const discountCode = this.input?.value.trim();
        if (!discountCode) return;

        this.applyDiscount(discountCode);
      }

      applyDiscount(discountCode) {
        this.setLoading(true);
        this.setMessage('');

        const cartDrawerItems = document.querySelector('cart-drawer-items');
        const sectionsToRender = cartDrawerItems?.getSectionsToRender?.() || [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];

        const body = JSON.stringify({
          discount: discountCode,
          sections: sectionsToRender.map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((parsedState) => {
            if (
              discountCode &&
              (parsedState.status === 422 ||
                parsedState.errors ||
                (parsedState.description && !parsedState.sections))
            ) {
              this.setMessage(parsedState.description || parsedState.message || 'Code invalide');
              return;
            }

            if (!parsedState.sections) {
              if (discountCode) {
                this.setMessage('Code invalide');
              }
              return;
            }

            sectionsToRender.forEach((section) => {
              const targetRoot = document.getElementById(section.id);
              if (!targetRoot || !parsedState.sections?.[section.section]) return;

              const elementToReplace =
                targetRoot.querySelector(section.selector) || targetRoot;

              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });

            if (this.input) {
              this.input.value = '';
            }
            this.setMessage('');

            if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sangdouleur-cart-drawer-discount',
                cartData: parsedState,
              });
            }
          })
          .catch(() => {
            this.setMessage('Une erreur est survenue. Réessayez.');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;

        this.submitButton.classList.toggle('loading', isLoading);
        this.submitButton.toggleAttribute('disabled', isLoading);
        this.input?.toggleAttribute('disabled', isLoading);

        const spinner = this.submitButton.querySelector('.loading__spinner');
        spinner?.classList.toggle('hidden', !isLoading);
      }

      setMessage(message) {
        if (!this.message) return;

        if (!message) {
          this.message.hidden = true;
          this.message.textContent = '';
          return;
        }

        this.message.hidden = false;
        this.message.textContent = message;
      }
    }
  );
}
